<template>
  <div class="step1-wrapper">
    <div id="wechat-qr" v-if="false"></div>
    <div class="search-wrapper">
      <div class="header">
        <label class="title">重要！</label>
        <p class="tip">请在输入框中输入需要涨粉的公众号全称，点击“递<br />交”后进入下一步，请确保公众号名称填写正确。<br />个人号如需裂变，请联系客服</p>
      </div>

      <div class="filter">
        <input class="search-box" v-model="nickname" placeholder="请在此输入公众号名称" />
        <label class="search-btn" @click="search">递交</label>
      </div>

      <ul class="options">
        <li :class="['account-type', mpType === '1' ? 'active' : '']" @click="onChangeAccountType('1')">订阅号</li>
        <li :class="['account-type', mpType === '2' ? 'active' : '']" @click="onChangeAccountType('2')">服务号</li>
      </ul>

      <div class="loading" v-if="status === 'doing'">公众号搜索中...<label class="stop" @click="stop">取消</label></div>
      <div class="loading" v-if="status === 'none'">没有更多的搜索结果</div>

      <div class="content" v-if="status === 'done' && mpAccount">
        <MpAccount :isActive="true" :data="mpAccount" />
      </div>

      <div class="next" v-if="status === 'done' && mpAccount" @click="next">确认公众号无误，并进入下一步</div>
    </div>
  </div>
</template>

<script>
import Notes from '@/engine/Notes'

import MpAccount from '@/components/MpAccount.vue'

const state = {
  mpAccountInterval: undefined
}

export default {
  name: 'step1',
  components: {
    MpAccount,
  },
  data () {
    return {
      mpAccount: undefined,
      nickname: '',
      mpType: '1',
      status: '',
    }
  },
  mounted () {
    // if (WxLogin) {
    //   new WxLogin({
    //     self_redirect: true,
    //     id: 'wechat-qr',
    //     appid: 'wxca0c2dd741284a6a',
    //     scope: 'snsapi_login',
    //     redirect_uri: 'https://wanke.qun088.com',
    //     // state: '',
    //     // style: '',
    //     // href: '',
    //   })
    // }
  },
  methods: {
    search: function () {
      if (this.nickname) {
        this.mpAccount = undefined
        this.status = 'doing'
        if (state.mpAccountInterval) {
          clearInterval(state.mpAccountInterval)
        }
        state.mpAccountInterval = setInterval(() => {
          Notes.getMpAccountInfo({ nickname: this.nickname, mpType: this.mpType }).then((data) => {
            this.status = data.status
            if (data.status === 'done') {
              clearInterval(state.mpAccountInterval)
              this.mpAccount = data
            } else if (data.status === 'none') {
              clearInterval(state.mpAccountInterval)
            }
          })
        }, 1000)
      }
    },
    onChangeAccountType: function (type) {
      this.mpType = type
    },
    stop: function () {
      if (state.mpAccountInterval) {
        clearInterval(state.mpAccountInterval)
        this.status = ''
      }
    },
    next: function () {
      if (this.mpAccount) {
        this.globalData.mpAccount = this.mpAccount
        this.$router.push('/step2/')
      }
    },
  },
};
</script>

<style src="./index.scss" lang="scss"></style>
